import { render } from "./Sakura.vue?vue&type=template&id=a9935634&ts=true"
import script from "./Sakura.vue?vue&type=script&lang=ts"
export * from "./Sakura.vue?vue&type=script&lang=ts"

import "./Sakura.vue?vue&type=style&index=0&id=a9935634&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__